import store              from '../storage'

import JobsHome from '@/components/#public/job/JobsHome'

import Generate from '@/components/#pages/jobs/Generate'
import Info from '@/components/#pages/jobs/pages/Info'
import Name from '@/components/#pages/jobs/pages/Name'
import DeleteJob from '@/components/#pages/jobs/pages/DeleteJob'
import Candidates from '@/components/#pages/jobs/Candidates'
import HomeCandidate from '@/components/#pages/jobs/pages/HomeCandidate'
import CandidatesList from '@/components/#pages/jobs/pages/CandidatesList'

import JobsRecomendation from '@/components/#public/job/JobsRecomendation'

/**
 * POSIBLE ::
 * @deprecated
 */
import CandidatesRecomendation from '@/components/#pages/candidates_gold/CandidatesRecomendation'
import CandidatesRecomendationCV from '@/components/#pages/candidates_gold/CandidateCV'

import CandidateCV from '@/components/#pages/student_profile/StudentCV'
import Match from "../components/#pages/jobs/pages/Match";


// import CandidateInfo from '@/components/auth/pages/jobs/pages/CandidateInfo'
export default [
    {
        path: '/empleos',
        component: () => import('@/views/Empleos.vue')  //JobsHome
    },
    {
        path: '/job/:id/recomendation',
        component: CandidatesRecomendation,
        beforeEnter(to, from, next) {
            if(store.getters.typeOrigin == 'enterprise'){
                next()
                return
            }
            next('/profile')
        }
    },
    {
        path: '/job/:id/recomendation/cv',
        component: CandidatesRecomendationCV,
        beforeEnter(to, from, next) {
            if(store.getters.typeOrigin == 'enterprise'){
                next()
                return
            }
            next('/profile')
        }
    },
    {
        path: '/jobs/recomendation',
        component: JobsRecomendation,
        beforeEnter(to, from, next) {
            if(store.getters.typeOrigin == 'student'){
                next()
                return
            }
            next('/profile')
        }
    },
    {
        path: '/job/generate',
        component: Generate,
        meta:{
            requiresAuth: true
        },
        children:[
            {
                path: '/',
                component: Info
            },
            {
                path: ':id?/name',
                component: Name
            },
            {
                path: ':id?/match',
                component: Match
            },
            {
                path: ':id?/remove',
                component: DeleteJob
            }
        ]
    },
    {
        path: '/job/:idjob/candidates',
        component: Candidates,
        beforeEnter(to, from, next) {
            if(store.getters.typeOrigin == 'enterprise'){
                next()
                return
            }
            next('/profile')
        },
        meta:{
            requiresAuth: true
        },
        children:[
            {
                path: '/',
                component: HomeCandidate
            },
            {
                path: 'view',
                component: CandidatesList
            },
            //FIXME: Remover este componente (CandidateInfo)
            // {
            //     path: 'view/:candidateid',
            //     component: CandidateInfo
            // }
        ]
    },
    {
        path: '/candidate',
        name: 'candidate_profile_cv',
        component: CandidateCV,
        meta:{
            requiresAuth: true
        },
    }
]



// WEBPACK FOOTER //
// ./src/router/jobs.js